import { Button, Spinner } from "@chakra-ui/react";

export default function LoadingButton() {
  return (
    <Button isDisabled={true} variant="outline">
      <Spinner size="sm" />
    </Button>
  );
}
